import React, {useCallback} from 'react';
import {parseInlineParams} from '../../utils/parseInlineParams';
import InlineParamInput from '../inlineParamInput/InlineParamInput';
import * as css from './InlineTemplateRow.css';
import {InlineTemplateItem} from '../../types/templateStructure';
import {useTranslation} from 'react-i18next';
import {useVariables} from '../../../../assets/objects/Variables';
import {convertToHtml} from '../../utils/formatUtils';

interface InlineTemplateRowProps {
    item: InlineTemplateItem;
    structureIndex: number;
    onChange?: (updatedItem: InlineTemplateItem) => void;
    onEditableFocus?: (element: HTMLElement | null) => void;
    onEditableCursorMove?: () => void;
}

function InlineTemplateRow({item, structureIndex, onChange, onEditableFocus, onEditableCursorMove}: InlineTemplateRowProps) {
    const {defaultVariables} = useVariables();
    const {t} = useTranslation('variables');
    
    const handleParamChange = useCallback((index: number, htmlContent: string) => {
        if(onChange && item.params) {
            const updatedParams = item.params.map(p => 
                p.index === index 
                    ? {...p, value: htmlContent}
                    : p
            );
            onChange({
                ...item,
                params: updatedParams
            });
        }
    }, [item, onChange]);

    const renderSegments = () => {
        const segments = parseInlineParams(item?.value, item?.params || []);
        const elements: React.ReactNode[] = [];

        segments.forEach((segment, index) => {
            if(segment.type === 'text') {
                const formattedHtml = convertToHtml(segment.value, defaultVariables, t);
                elements.push(
                    <css.staticText key={`text-${index}`}>
                        {formattedHtml}
                    </css.staticText>
                );
            } else {
                const formattedHtml = convertToHtml(segment.value, defaultVariables, t);
                elements.push(
                    <InlineParamInput
                        key={`param-${segment.index}`}
                        index={segment.index}
                        structureIndex={structureIndex}
                        content={formattedHtml}
                        onChange={handleParamChange}
                        onEditableFocus={onEditableFocus}
                        onEditableCursorMove={onEditableCursorMove}
                    />
                );
            }
        });

        return elements;
    };

    return (
        <css.container>
            {renderSegments()}
        </css.container>
    );
}

export default InlineTemplateRow;
